import Cookies from 'js-cookie';

const REBRAND_ANNOUNCEMENT_COOKIE = 'scpAnnouncementClosed',
      REBRAND_ANNOUNCEMENT_DISMISSED_VALUE = 'true',
      REBRAND_ANNOUNCEMENT_EXPIRY_IN_DAYS = 365;

class RebrandAnnouncement {
	constructor() {
		this.announcementElement = document.querySelector('#rebrandAnnouncement');
		this.closeButton = document.querySelector('#closeRebrandAnnouncement');
		this.init();
	}

	init() {
		if (!this.announcementElement || !this.closeButton) {
			return;
		}

		if (Cookies.get(REBRAND_ANNOUNCEMENT_COOKIE) === REBRAND_ANNOUNCEMENT_DISMISSED_VALUE) {
			return;
		}

		this.closeButton.addEventListener('click', this.close.bind(this), {'once': true});
		this.announcementElement.hidden = false;
	}

	close() {
		this.announcementElement.hidden = true;
		Cookies.set(
			REBRAND_ANNOUNCEMENT_COOKIE,
			REBRAND_ANNOUNCEMENT_DISMISSED_VALUE,
			{
				'expires': REBRAND_ANNOUNCEMENT_EXPIRY_IN_DAYS
			}
		);
	}
}

export default RebrandAnnouncement;